"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwFilterList = _interopRequireDefault(require("../cwfilterlist/CwFilterList"));

var _CwButton = _interopRequireDefault(require("../cwbutton/CwButton"));

var _CwDoubleFilterList = _interopRequireDefault(require("./CwDoubleFilterList.scss"));

var CwDoubleFilterList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwDoubleFilterList, _React$Component);

  function CwDoubleFilterList(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwDoubleFilterList);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwDoubleFilterList).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSelectedByName", function (arr, values) {
      var results = [];

      if (typeof arr == 'undefined') {
        return results;
      }

      for (var i = 0, l = values.length; i < l; i++) {
        for (var j = 0, s = arr.length; j < s; j++) {
          if (values[i] === arr[j].name) {
            results.push(arr[j].id);
            break;
          }
        }
      }

      return results;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSelectedById", function (arr, values) {
      var results = [];

      if (typeof arr == 'undefined') {
        return results;
      }

      for (var i = 0, l = values.length; i < l; i++) {
        for (var j = 0, s = arr.length; j < s; j++) {
          if (values[i] === arr[j].id) {
            results.push(arr[j]);
            break;
          }
        }
      }

      return results.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getNonSelectedById", function (arr, values) {
      var selected = _this.getSelectedById(arr, values);

      var unselected = [];

      if (typeof arr == 'undefined') {
        return unselected;
      }

      unselected = unselected.concat(arr);

      for (var i = 0, l = selected.length; i < l; i++) {
        var index = unselected.indexOf(selected[i]);
        unselected.splice(index, 1);
      }

      return unselected.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getIdsFromObjects", function (arr) {
      var result = [];

      for (var i = 0, l = arr.length; i < l; i++) {
        result.push(arr[i].id);
      }

      return result;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addAllToSelection", function () {
      var newValue = _this.getIdsFromObjects(_this.props.items ? _this.props.items : []);

      _this.props.onChange(newValue);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addSelectedToSelection", function () {
      var previousSelection = _this.props.value ? _this.props.value : [];
      var selected = _this.state.selectedAItems;
      var newValue = [];
      newValue = newValue.concat(previousSelection);
      newValue = newValue.concat(selected);

      _this.props.onChange(newValue);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeSelectedFromSelection", function () {
      var previousSelection = _this.props.value ? _this.props.value : [];
      var selected = _this.state.selectedBItems;
      var newValue = [];
      newValue = newValue.concat(previousSelection);

      for (var i = 0, l = selected.length; i < l; i++) {
        var index = newValue.indexOf(selected[i]);
        newValue.splice(index, 1);
      }

      _this.props.onChange(newValue);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeAllFromSelection", function () {
      var newValue = [];

      _this.props.onChange(newValue);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleListBChange", function (event) {
      var selection = event ? event : [];
      var intArray = [];

      for (var i = 0, l = selection.length; i < l; i++) {
        intArray.push(parseInt(selection[i], 10));
      }

      _this.setState({
        selectedBItems: intArray
      });

      if (_this.props.onRightSelected) {
        _this.props.onRightSelected(event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleListBBlur", function () {
      if (_this.props.onRightBlur) {
        _this.props.onRightBlur();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleListBFocus", function () {
      if (_this.props.onRightFocus) {
        _this.props.onRightFocus();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleListAChange", function (event) {
      var selection = event ? event : [];
      var intArray = [];

      for (var i = 0, l = selection.length; i < l; i++) {
        intArray.push(parseInt(selection[i], 10));
      }

      _this.setState({
        selectedAItems: intArray
      });

      if (_this.props.onLeftSelected) {
        _this.props.onLeftSelected(event);
      }
    });
    _this.state = {
      selectedAItems: [],
      selectedBItems: []
    };
    return _this;
  }

  (0, _createClass2.default)(CwDoubleFilterList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // NOTE: Perform any magic you need when the filterlist re-mounts (i.e. after pod collapses then re-expands)
      if (this.props.onLoad) {
        this.props.onLoad();
      }
    }
    /**
     * Adds everything in list A to list B
     * The list updates based on what the value is set. So we set the value to
     * all objects and what happens is list A gets an empty array and list B
     * gets an array of all objects
     */

  }, {
    key: "render",
    value: function render() {
      var filter = this.props.value ? this.props.value : [];
      var _this$props = this.props,
          items = _this$props.items,
          includeFilter = _this$props.includeFilter,
          disabled = _this$props.disabled,
          leftListLabel = _this$props.leftListLabel,
          rightListLabel = _this$props.rightListLabel,
          leftFilter = _this$props.leftFilter,
          rightFilter = _this$props.rightFilter,
          mapKey = _this$props.mapKey,
          size = _this$props.size,
          placeholder = _this$props.placeholder;
      var selectedAItems = this.state.selectedAItems ? this.state.selectedAItems : [];
      var selectedBItems = this.state.selectedBItems ? this.state.selectedBItems : [];
      return _react.default.createElement("div", {
        "data-cwid": this.props.cwId,
        className: _CwDoubleFilterList.default.wrap
      }, _react.default.createElement("div", null, _react.default.createElement(_CwFilterList.default, {
        options: filter.length > 0 ? this.getNonSelectedById(items, filter) : items,
        value: selectedAItems,
        onChange: this.handleListAChange,
        cwId: 'flistA' + this.props.cwId,
        listHeader: leftListLabel,
        placeholder: placeholder,
        size: size,
        defaultFilter: leftFilter,
        includeFilter: includeFilter,
        mapKey: mapKey,
        disabled: disabled,
        allowMultiSelect: this.props.leftAllowMultiSelect
      })), _react.default.createElement("div", {
        className: _CwDoubleFilterList.default.buttons
      }, _react.default.createElement(_CwButton.default, {
        value: ">>",
        onClick: this.addAllToSelection,
        disabled: disabled
      }), _react.default.createElement(_CwButton.default, {
        value: ">",
        onClick: this.addSelectedToSelection,
        disabled: disabled
      }), _react.default.createElement(_CwButton.default, {
        value: "<",
        onClick: this.removeSelectedFromSelection,
        disabled: disabled
      }), _react.default.createElement(_CwButton.default, {
        value: "<<",
        onClick: this.removeAllFromSelection,
        disabled: disabled
      })), _react.default.createElement("div", null, _react.default.createElement(_CwFilterList.default, {
        options: filter.length > 0 ? this.getSelectedById(items, filter) : [],
        value: selectedBItems,
        onChange: this.handleListBChange,
        onBlur: this.handleListBBlur,
        onFocus: this.handleListBFocus,
        cwId: 'flistB' + this.props.cwId,
        listHeader: rightListLabel,
        placeholder: placeholder,
        size: size,
        defaultFilter: rightFilter,
        includeFilter: includeFilter,
        mapKey: mapKey,
        disabled: disabled,
        allowMultiSelect: this.props.rightAllowMultiSelect
      })));
    }
  }]);
  return CwDoubleFilterList;
}(_react.default.Component);

CwDoubleFilterList.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Callback function that is fired when combobox's selection changes
   */
  onChange: _propTypes.default.func,

  /**
   * List of all items unfiltered. Must contain at least "id" and "name" fields.
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number,
    name: _propTypes.default.string
  })),

  /**
   * Path in screenData where the List's value will be stored and retrieved
   */
  value: _propTypes.default.arrayOf(_propTypes.default.number),

  /**
   * Label for the left list box
   */
  leftListLabel: _propTypes.default.string,

  /**
   * Label for the right list box
   */
  rightListLabel: _propTypes.default.string,

  /**
   * Default filter for left list
   */
  leftFilter: _propTypes.default.string,

  /**
   * Default filter for right list
   */
  rightFilter: _propTypes.default.string,

  /**
   * Boolean to render the filter or not
   */
  includeFilter: _propTypes.default.bool,

  /**
   * Key for the filter map lookup used to filter the list by property
   */
  mapKey: _propTypes.default.string,

  /**
   * Used to disable the entire widget (lists, filters and buttons)
   */
  disabled: _propTypes.default.bool,

  /**
   * Callback function that is fired when selection in the left filter list changes
   */
  onLeftSelected: _propTypes.default.func,

  /**
   * Callback function that is fired when selection in the right filter list changes
   */
  onRightSelected: _propTypes.default.func,

  /**
   * Allows the user to select multiple items at the same time in the left flist
   */
  leftAllowMultiSelect: _propTypes.default.bool,

  /**
   * Allows the user to select multiple items at the same time in the right list
   */
  rightAllowMultiSelect: _propTypes.default.bool,

  /**
   * handler for when the right-hand-side list loses focus
   */
  onRightBlur: _propTypes.default.func,

  /**
   * handler for when the right-hand-side list receives focus
   */
  onRightFocus: _propTypes.default.func
};
CwDoubleFilterList.defaultProps = {
  leftListLabel: 'List A',
  rightListLabel: 'List B',
  leftAllowMultiSelect: true,
  rightAllowMultiSelect: true
};
var _default = CwDoubleFilterList;
exports.default = _default;